"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ChipViewContainer = exports.resolveFilterValueLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _creators = require("../../../../../redux/creators");

var _utils = require("../../../../../configuration/utils");

var _ResetFiltersComponent = _interopRequireDefault(require("./ResetFiltersComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ChipView = function ChipView(_ref) {
  var name = _ref.name,
      index = _ref.index,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "chip slide-in-left animated",
    role: "button",
    key: index || 0,
    onClick: onClick
  }, name, /*#__PURE__*/_react["default"].createElement("div", {
    className: "chip__close-button"
  }));
};

var resolveFilterValueLabel = function resolveFilterValueLabel(filter, pepFilters) {
  var filterValueLabel = filter.value;
  pepFilters.forEach(function (pepFilter) {
    if (pepFilter.property === filter.dataKey) {
      pepFilter.values.forEach(function (pepFilterValue) {
        if (pepFilterValue.value === filter.value) {
          filterValueLabel = pepFilterValue.label;
        }
      });
    }
  });
  return filterValueLabel;
};

exports.resolveFilterValueLabel = resolveFilterValueLabel;

var ChipViewContainer = function ChipViewContainer() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var useSelectedFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedFilters;
  });
  var pimApi = (0, _reactRedux.useSelector)(function (state) {
    return state.productList;
  });
  var pepFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.pepFilters;
  });

  var closeHandler = function closeHandler(filter) {
    pimApi.unsetFilter(filter.dataKey, filter.value);
    dispatch((0, _creators.setActiveProducts)(pimApi.filteredProducts()));
    dispatch((0, _creators.setSelectedFilters)((0, _utils.createActiveFilters)(pimApi.filters)));
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "chip-container"
  }, useSelectedFilters.map(function (filter, index) {
    return /*#__PURE__*/_react["default"].createElement(ChipView, {
      key: "chipview-".concat(filter.value, "-").concat(index),
      name: resolveFilterValueLabel(filter, pepFilters),
      index: index,
      onClick: function onClick() {
        return closeHandler(filter);
      }
    });
  }), useSelectedFilters.length > 0 && /*#__PURE__*/_react["default"].createElement(_ResetFiltersComponent["default"], {
    type: "link"
  })));
};

exports.ChipViewContainer = ChipViewContainer;
var _default = ChipView;
exports["default"] = _default;